module.exports = __webpack_public_path__ + "img/mm.1d208cb9.svg";